import ErrorMessage from "../errors/ErrorMessage";

export default function halfText(props) {

  return (
    <div className="flex flex-wrap -mx-3">
      <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
        {props.color ? (
          <input className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg 
                focus:ring-${props.color} focus:border-${props.color} block w-full p-2.5 mb-4`} id={props.id} type={props.type} name={props.name}
            placeholder={props.placeholder} onChange={props.handleInputChange(props.name)}>
          </input>
        ) : (
          <input className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg 
          focus:ring-primary-200 focus:border-primary-200 block w-full p-2.5 mb-4" id={props.id} type={props.type} name={props.name}
            placeholder={props.placeholder} onChange={props.handleInputChange(props.name)}>
          </input>
        )}

        {props.error ? (
          <div className="-mt-2">
            <ErrorMessage message={props.message}></ErrorMessage>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="w-full md:w-1/2 px-3">
      </div>
    </div>
  )
}

